/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { standardSpinner } from '../../../../helpers/spinners'
import { positionChangeWidthSm, promptsArray, expertReviewDiscount, expertReviewRate, maxExpertReviewRate } from '../../../../helpers/variableDefaults'
import { descriptionTextField } from '../../../../helpers/textfields'
import { selectElementWithIndex } from '../../../../helpers/selects'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { titleAndAdvisoryJSX, saveAndCancelButtonsJSX, aboutMeSingleElementJSX } from '../../../../helpers/commonJSX'
import { reviewRateTextField } from '../../../../helpers/textfields'
import { standardToggle } from '../../../../helpers/toggles'
import { switchElement } from '../../../../helpers/switches'

export const rateAndVisibilityJSX = (
  user, setUser,
  newRateAndVisibility, setNewRateAndVisibility,
  loadingRateAndVisibility, setLoadingRateAndVisibility,
  saveSuccessful, setSaveSuccessful, resetSaveSuccessful,
  bioErrors, setBioErrors,
  width
) => {

  const showSaveAndCancelButtons = () => {
    // console.log('newRateAndVisibility.reviewRate', newRateAndVisibility.reviewRate)
    // console.log('user.reviewerProfile.reviewRate', user.reviewerProfile.reviewRate)
    // console.log('newRateAndVisibility.isVisible.length', newRateAndVisibility.isVisible)
    // console.log('user.reviewerProfile.isVisible.length', user.reviewerProfile.isVisible)

    return (
      'reviewRate' in newRateAndVisibility
      && 'isVisible' in newRateAndVisibility
      && 'reviewerProfile' in user
      && 'reviewRate' in user.reviewerProfile
      && 'isVisible' in user.reviewerProfile
      && 
      (
        Math.floor(newRateAndVisibility.reviewRate) !== Math.floor(user.reviewerProfile.reviewRate)
        || newRateAndVisibility.isVisible !== user.reviewerProfile.isVisible
      )
    )
  }

  const handleReviewerProfileItemChange = (e, setErrors, setForm, form) => {
    // e.preventDefault()

    setBioErrors({ ...bioErrors, rateAndVisibility: false })
    // setSaveSuccessful({ ...saveSuccessful, aboutMe: false })
    resetSaveSuccessful()
    // console.log('e ->', e)
    // console.log('e.target ->', e.target)

    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)
    // console.log('index ->', index)

    if (name === 'reviewRate' && value > -1) {
      setForm({
        ...form,
        [name]: Math.floor(value),
      })
    } else if (name === 'isVisible') {
      setForm({
        ...form,
        [name]: e.target.checked,
      })
    }
  }

  const handleCancelPressed = () => {
    // console.log('handleCancelPressed runs')
    setBioErrors({ ...bioErrors, rateAndVisibilityJSX: false })
    // setSaveSuccessful({ ...saveSuccessful, aboutMe: false })
    resetSaveSuccessful()

    setNewRateAndVisibility({ 
      reviewRate: Math.floor(user.reviewerProfile.reviewRate),
      isVisible: user.reviewerProfile.isVisible,
    })
  }

  const handleSavePressed = async () => {
    // console.log('handleSavePressed runs')
    const objectToUpload = {
      reviewRate: !('reviewRate' in newRateAndVisibility) || (newRateAndVisibility.reviewRate === undefined || newRateAndVisibility.reviewRate === null) || Math.floor(newRateAndVisibility.reviewRate) < Math.floor(expertReviewRate * expertReviewDiscount) ? Math.floor(expertReviewRate * expertReviewDiscount) : Math.floor(newRateAndVisibility.reviewRate) > maxExpertReviewRate ? maxExpertReviewRate : Math.floor(newRateAndVisibility.reviewRate),
      isVisible: newRateAndVisibility.isVisible,
    }
    // console.log('objectToUpload ->', objectToUpload)
    // console.log('objectToUpload.aboutMe.length > 0 ->', objectToUpload.aboutMe.length > 0)
    // console.log('lengths are equal ->', objectToUpload.aboutMe.length === bioObject.aboutMe.length)
    // console.log('arrays are different ->', !(objectToUpload.aboutMe.length === bioObject.aboutMe.length && bioObject.aboutMe.filter((aboutMeItem, index) => aboutMeItem !== objectToUpload.aboutMe[index]).length === 0))

    // Upload Modifications
    if (
      objectToUpload.reviewRate >= Math.floor(expertReviewRate * expertReviewDiscount) 
      && objectToUpload.reviewRate <= Math.floor(maxExpertReviewRate)
      && 'isVisible' in objectToUpload
      && (objectToUpload.isVisible === true || objectToUpload.isVisible === false)
    ) {
      console.log('attempting upload rate and visibility')
      setLoadingRateAndVisibility(true)
      setBioErrors({ ...bioErrors, rateAndVisibilityJSX: false })
      resetSaveSuccessful()
      
      try {
        // PUT request with updated profile object
        // await axios.put(`/api/users/${userId}`, newForm, {
        await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/reviewer-profiles/${user.reviewerProfile._id}`, objectToUpload, {
          headers: {
            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
          },
        })
        const newReviewerProfile = {
          ...user.reviewerProfile,
          reviewRate: objectToUpload.reviewRate,
          isVisible: objectToUpload.isVisible,
        }

        setNewRateAndVisibility({ 
          reviewRate: objectToUpload.reviewRate,
          isVisible: objectToUpload.isVisible, 
        })

        setUser({ ...user, reviewerProfile: { ...newReviewerProfile } })

        setBioErrors({ ...bioErrors, rateAndVisibilityJSX: false })
        setSaveSuccessful({ ...saveSuccessful, rateAndVisibilityJSX: true })
        setLoadingRateAndVisibility(false)

        console.log('uploading new rate and visibility successful')
        
      } catch (error) {
        console.log(error)
        setBioErrors({ ...bioErrors, rateAndVisibilityJSX: true })
        setLoadingRateAndVisibility(false)
      }
    }
  }

  return (
    <Box
      sx={{
        py: 3, my: 2,
        width: '90%',
        maxWidth: '600px',
        backgroundColor: showSaveAndCancelButtons() ? 'lightgray' : 'whitesmoke',
        borderRadius: 3, boxShadow: 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        {/* Rate and Visibility Section */}
        {/* Title and Advisory JSX */}
        {/* {titleAndAdvisoryJSX(
          'Rate', 
          // 'Rate and Availability', 
          '*What is your price for a review?',
          // '*Are you available for reviewing and at what price?',
          0
        )} */}
        

        {/* Available for Reviews Toggle */}
        {/* <Box
          sx={{
            // backgroundColor: 'yellow',
            mt: 0,
            width: '100%', maxWidth: '200px',
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
            // flexWrap: 'wrap',
          }}
        >
          <Typography
            sx={{
              mr: 3,
              fontWeight: 'bold',
            }}
          >
            Available:
          </Typography>

          {switchElement('isVisible', newRateAndVisibility.isVisible, false, handleReviewerProfileItemChange, setBioErrors, setNewRateAndVisibility, newRateAndVisibility)}
        </Box> */}

        {/* Rate Textfield */}
        <Box
          sx={{
            // backgroundColor: 'yellow',
            mt: 1,
            width: '100%', maxWidth: '200px',
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
            // flexWrap: 'wrap',
          }}
        >
          {/* Label */}
          <Typography
            sx={{
              mr: 3,
              // fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            Review Rate:
          </Typography>

          {/* TextField */}
          {reviewRateTextField('reviewRate', '', 'text', newRateAndVisibility.reviewRate, '', false, false, handleReviewerProfileItemChange, setNewRateAndVisibility, newRateAndVisibility, setBioErrors)}
        </Box>

        {/* Save and Cancel Buttons */}
        {showSaveAndCancelButtons() &&
          saveAndCancelButtonsJSX(
            loadingRateAndVisibility,
            (!(showSaveAndCancelButtons()) || loadingRateAndVisibility),
            handleCancelPressed,
            handleSavePressed,
            0,
            bioErrors.rateAndVisibility ? 0 : 2,
            2,
            'warning',
            'primary'
          )
        }

        {/* Loading */}
        {loadingRateAndVisibility &&
          advisoryTypography(`Uploading Changes...`, 'center')
        }

        {/* Error Message */}
        {bioErrors.rateAndVisibility &&
          standardErrorContainer(`There was an error uploading the changes. Check your Internet connection and try again.`)
        }

        {/* Save Successful */}
        {saveSuccessful.rateAndVisibility &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}